import apiRequest from "./apiClient";

export async function fetchDeviceAssessment(deviceId) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}/assessment`);
  return body.data;
}

export async function fetchCategoryAssessment(categoryId) {
  const body = await apiRequest(`/api/v1/devices/assessment/category/${categoryId}`);
  return body.data;
}

export async function fetchBrandAssessment(brandId, categoryId) {
  const body = await apiRequest(`/api/v1/devices/assessment/brand/${brandId}/category/${categoryId}`);
  return body.data;
}

export async function fetchEffectiveBrandAssessment(brandId, categoryId) {
  const body = await apiRequest(`/api/v1/devices/assessment/brand/${brandId}/category/${categoryId}/effective`);
  return body.data;
}

export async function applyBrandTemplateToModels(brandId, categoryId, { mode = "merge", deviceIds } = {}) {
  const params = new URLSearchParams({ mode });
  if (deviceIds?.length) {
    deviceIds.forEach((id) => params.append("deviceIds", String(id)));
  }
  const body = await apiRequest(
    `/api/v1/devices/assessment/brand/${brandId}/category/${categoryId}/apply-to-models?${params.toString()}`,
    { method: "POST" }
  );
  return body.data;
}

export async function promoteDeviceToBrandTemplate(deviceId) {
  const body = await apiRequest(`/api/v1/devices/${deviceId}/assessment/promote-to-brand`, {
    method: "POST",
  });
  return body.data;
}

export async function createBrandQuestion(brandId, categoryId, payload) {
  const body = await apiRequest(`/api/v1/devices/brand/${brandId}/category/${categoryId}/questions`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function createBrandDefect(brandId, categoryId, payload) {
  const body = await apiRequest(`/api/v1/defects/brand/${brandId}/category/${categoryId}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function cloneAssessmentToDevice(targetDeviceId, sourceDeviceId) {
  await apiRequest(
    `/api/v1/devices/${targetDeviceId}/assessment/clone?sourceDeviceId=${sourceDeviceId}`,
    { method: "POST" }
  );
}

export async function copyCategoryTemplate(sourceCategoryId, targetCategoryId) {
  const body = await apiRequest(
    `/api/v1/devices/assessment/category/${sourceCategoryId}/copy?targetCategoryId=${targetCategoryId}`,
    { method: "POST" }
  );
  return body.data;
}

export async function applyCategoryTemplateToModels(categoryId, { mode = "merge", deviceIds } = {}) {
  const params = new URLSearchParams({ mode });
  if (deviceIds?.length) {
    deviceIds.forEach((id) => params.append("deviceIds", String(id)));
  }
  const body = await apiRequest(
    `/api/v1/devices/assessment/category/${categoryId}/apply-to-models?${params.toString()}`,
    { method: "POST" }
  );
  return body.data;
}

export async function createCategoryQuestion(categoryId, payload) {
  const body = await apiRequest(`/api/v1/devices/category/${categoryId}/questions`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}

export async function createCategoryDefect(categoryId, payload) {
  const body = await apiRequest(`/api/v1/defects/category/${categoryId}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return body.data;
}
